import { useRef, useState, useEffect } from "react";

export const SeasonCarousel = ({
  seasons,
  selectedSeason,
  onSeasonChange,
  onSearch,
  searchValue,
}) => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const updateScrollButtons = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  useEffect(() => {
    updateScrollButtons();
  }, [seasons]);

  const scroll = (direction) => {
    const el = scrollRef.current;
    if (!el) return;
    const amount = direction === "left" ? -200 : 200;
    el.scrollBy({ left: amount, behavior: "smooth" });
  };

  return (
    <div className="space-y-3">
      <input
        type="text"
        value={searchValue}
        onChange={(e) => onSearch(e.target.value)}
        placeholder="Search seasons..."
        aria-label="Search seasons"
        className="w-full sm:w-64 px-3 py-2 bg-flyers-charcoal border border-flyers-dark-gray rounded text-white text-sm placeholder-flyers-mid-gray focus:outline-none focus:border-flyers-orange transition-colors"
      />

      <div className="flex items-center gap-2">
        <button
          onClick={() => scroll("left")}
          disabled={!canScrollLeft}
          aria-label="Scroll seasons left"
          className="flex-shrink-0 p-1.5 bg-flyers-charcoal border border-flyers-dark-gray rounded hover:border-flyers-orange transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <div
          ref={scrollRef}
          onScroll={updateScrollButtons}
          className="flex gap-2 overflow-x-auto scrollbar-hide"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {seasons.map((s) => (
            <button
              key={s.SeasonID}
              onClick={() => onSeasonChange(s.SeasonID)}
              aria-label={`Season ${s.season}`}
              className={`flex-shrink-0 px-4 py-1.5 rounded font-heading text-sm font-bold uppercase tracking-wider transition-colors duration-150 ${
                selectedSeason === s.SeasonID
                  ? "bg-flyers-orange text-white"
                  : "bg-flyers-charcoal text-flyers-light-gray border border-flyers-dark-gray hover:border-flyers-orange hover:text-white"
              }`}
            >
              {s.season}
            </button>
          ))}
          {seasons.length === 0 && (
            <span className="text-flyers-mid-gray text-sm py-1.5">No seasons found</span>
          )}
        </div>

        <button
          onClick={() => scroll("right")}
          disabled={!canScrollRight}
          aria-label="Scroll seasons right"
          className="flex-shrink-0 p-1.5 bg-flyers-charcoal border border-flyers-dark-gray rounded hover:border-flyers-orange transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};
